var map = {
	"./icon_bed.png": "0b93",
	"./icon_diamond.png": "682e",
	"./icon_jigou.png": "b713",
	"./icon_jigou_line.png": "67a4",
	"./icon_location.png": "c8ac",
	"./icon_nurse.png": "cde3",
	"./icon_room.png": "1f42",
	"./icon_service.png": "fc7d",
	"./icon_socail_worker.png": "1832",
	"./icon_volunteer.png": "76ae",
	"./img/0146137d.png": "aea9",
	"./img/11feef877.png": "a239",
	"./img/12.74947a2 (1).png": "2869",
	"./img/12.74947a2.png": "b9d5",
	"./img/14.dfc68f4.png": "810d",
	"./img/3.png": "1f66",
	"./img/32.png": "cf3b",
	"./img/411.0e49f3b.png": "57f1",
	"./img/422c6817d7.png": "fbf1",
	"./img/433.c5a9f31.png": "c44e",
	"./img/444.519ef45.png": "16f1",
	"./img/58.e28b1c0.png": "7396",
	"./img/59.png": "dcdcc",
	"./img/60.png": "350d",
	"./img/61.png": "99df",
	"./img/63 (1).png": "30f6",
	"./img/63-1.png": "3dad",
	"./img/63.png": "969e",
	"./img/64.png": "720e",
	"./img/65.png": "6902",
	"./img/Consulting/c1.png": "c80a",
	"./img/Consulting/c2.png": "51fb",
	"./img/Consulting/c3.png": "e136",
	"./img/Consulting/c4.png": "a7dd",
	"./img/Consulting/c5.png": "e36e",
	"./img/Consulting/cyyj1.png": "9abb",
	"./img/Consulting/cyyj2.png": "8075",
	"./img/Consulting/cyyj3.png": "6b6f",
	"./img/Consulting/cyyj4.png": "2900",
	"./img/Consulting/cyyj5.png": "13f5",
	"./img/Consulting/ys1.png": "36ef",
	"./img/Consulting/ys2.png": "c5f8",
	"./img/Consulting/ys3.png": "3d2d",
	"./img/banner22.png": "9a28",
	"./img/bannershow.png": "d23b",
	"./img/bannertext.ff3237d.png": "dfac",
	"./img/bg.722080d.png": "64da",
	"./img/bg.dfc68f4.png": "30fd",
	"./img/bg1.png": "756d",
	"./img/bg123.png": "0e5c",
	"./img/bg2.png": "ff95",
	"./img/bg3.png": "7d5d",
	"./img/bg_0.png": "9105",
	"./img/bg_1.png": "d5b1",
	"./img/bg_2.png": "a2cd",
	"./img/bg_3.png": "c0f3",
	"./img/bg_4.png": "08e2",
	"./img/bgmain.cfe7451.png": "ab55",
	"./img/bottom_circle.4e50268.png": "a68a",
	"./img/build.543dd76.png": "752f",
	"./img/cbib.3166b1c.png": "8ad4",
	"./img/chatBg1.8d07a09.png": "f27b",
	"./img/company1.45b286f.png": "bfa9",
	"./img/company2.png": "5612",
	"./img/dyQrcode.png": "b907",
	"./img/guanzhu.png": "2b60",
	"./img/header.png": "a16c",
	"./img/home/360度，VR，AR，AI，只能科技，全息投影.png": "0c58",
	"./img/home/logo-h.png": "2265",
	"./img/home/logo-hw.png": "99d7",
	"./img/home/logo-hw2.png": "66e5",
	"./img/home/logo.png": "68ea",
	"./img/home/tel.png": "a24e",
	"./img/icon2.png": "e82b",
	"./img/innovation/bg1.png": "4254",
	"./img/innovation/bg2.png": "3ccb",
	"./img/innovation/bg3.png": "870c",
	"./img/innovation/s1.png": "ef5f",
	"./img/innovation/s2.png": "47eb",
	"./img/innovation/s3.png": "146d",
	"./img/logo-b.png": "e068",
	"./img/media.png": "464e",
	"./img/newEdition/31.png": "9e3a",
	"./img/newEdition/32.png": "c0c6",
	"./img/newEdition/33.png": "77d7",
	"./img/newEdition/34.png": "edb7",
	"./img/newEdition/35.png": "f87d",
	"./img/newEdition/63-1.png": "ca8e",
	"./img/newEdition/63.png": "96a7",
	"./img/newEdition/64-1.png": "fe7e",
	"./img/newEdition/64.png": "243c",
	"./img/newEdition/65-1.png": "1c29",
	"./img/newEdition/65.png": "7acf",
	"./img/newEdition/形状.png": "33cc",
	"./img/newEdition/形状1.png": "243e",
	"./img/newEdition/形状2.png": "806e",
	"./img/newEdition/形状3.png": "b84a",
	"./img/newEdition/形状5.png": "1e76",
	"./img/newEdition/形状6.png": "1c42",
	"./img/newphone.png": "8860",
	"./img/noimg.png": "510b",
	"./img/position.png": "b9f8",
	"./img/researchInstitute/1.png": "db1c",
	"./img/researchInstitute/2.png": "37bc",
	"./img/researchInstitute/3.png": "4885",
	"./img/researchInstitute/icon1.png": "99f1",
	"./img/researchInstitute/icon2.png": "0668",
	"./img/researchInstitute/icon3.png": "ee4a",
	"./img/researchInstitute/icon4.png": "4856",
	"./img/smalldot.png": "5e31",
	"./img/smalldot1.png": "4186",
	"./img/tab-main.8a4ac8f.png": "7e96",
	"./img/teld.png": "8d33",
	"./img/toTop.png": "fa5f",
	"./img/tupianleft.png": "b23f",
	"./img/tupianright.png": "ff60",
	"./img/types.png": "9779",
	"./img/witness-bgc369221.png": "8f68",
	"./img/witness47b5311.png": "9acd",
	"./img/wxVideoAccount.png": "8bc9",
	"./img/xiazai2.png": "14f8",
	"./img/xiazai3.png": "555c",
	"./img/xiazai4.png": "425b",
	"./img/yjbg1.550eeb6.png": "5baa",
	"./img/ys1.png": "dd90",
	"./img/ys2.png": "7487",
	"./img/ys3.png": "44aa",
	"./img/zhengfangxing.png": "7247",
	"./img/zsbg.0b1914f.png": "d6a8",
	"./introduction.png": "bbc6",
	"./ky.png": "1f7a",
	"./location.png": "e6b6",
	"./org_icon.png": "12b9",
	"./sg.png": "e2fc",
	"./sght.png": "56aa",
	"./stq.png": "c8ae",
	"./wy.png": "3c41",
	"./xiazai.png": "f346"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";